import React, { useEffect, useState } from "react";

import Footer from "./Footer";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => {
  const [sidebarActive, setSidebarActive] = useState(false);
  const [pageIsScrolling, setPageIsScrolling] = useState(false);

  function showSidebarHandler() {
    setSidebarActive(true);
  }

  function hideSidebarHandler() {
    setSidebarActive(false);
  }

  useEffect(() => {
    const handlePageScroll = () => {
      if (window.pageYOffset > 80) {
        setPageIsScrolling(true);
      } else {
        setPageIsScrolling(false);
      }
    };

    window.addEventListener("scroll", handlePageScroll);

    return () => window.removeEventListener("scroll", handlePageScroll);
  }, [pageIsScrolling, setPageIsScrolling]);

  const showSidebarClass = sidebarActive ? "show-sidebar" : "";
  const navbarFixedClass = pageIsScrolling ? "navbar-fixed" : "";

  return (
    <>
      <Navbar
        navbarFixedClass={navbarFixedClass}
        onShowSidebar={showSidebarHandler}
      />
      <Sidebar
        showSidebarClass={showSidebarClass}
        onHideSidebar={hideSidebarHandler}
      />

      {children}
      <Footer />
    </>
  );
};

export default Layout;
